import { Container } from "react-bootstrap"
import { Helmet } from "react-helmet-async";
import Footer from './Homepages/Footer';

const TermsAndConditions = () => {
  return (
    <>
    <Helmet>
        <title>User Terms & Conditions | Techno Elevators Oman – Know Your Rights</title>
        <meta name="description" content="Review the Terms & Conditions for using Techno Elevators Oman’s website and services. Understand your rights, responsibilities, and our legal policies." />
        <meta name="keywords" content="techno elevators for villas,techno elevators for office buildings,commercial techno lift installation,high-rise techno elevators,techno elevator services in Muscat,elevator installation cost,home elevator installation near me,residential elevator installation,home elevator installers,lift installation services,elevator repair near me" />
        <link rel="canonical" href="https://www.techno-elevators.com/terms-and-conditions" />
      </Helmet>
     <Container>
         <div className="prose max-w-none p-6 spad">
        <h1>Terms and Conditions</h1>

        <p>Welcome to Techno Elevators LLC. By accessing or using our website and services, you agree to comply with the following terms and conditions. Please read them carefully.</p>

        <h2>1. Use of Services</h2>
        <p>Our services, including installation and maintenance of elevators, escalators, and travelators, are provided based on the specifications agreed with our clients. You agree to use our services in accordance with applicable laws and regulations.</p>

        <h2>2. Products</h2>
        <p>Techno Elevators LLC is the exclusive distributor for Hyundai elevators in Oman. All products sold, installed, or serviced by us are subject to Hyundai's manufacturer guidelines, and any warranties are as provided by the manufacturer.</p>

        <h2>3. Project Responsibilities</h2>
        <p>Clients are responsible for providing accurate information regarding project requirements, access, and compliance with building regulations. Techno Elevators LLC will not be liable for delays or damages caused by incomplete or inaccurate information.</p>

        <h2>4. Limitation of Liability</h2>
        <p>To the extent permitted by law, Techno Elevators LLC shall not be liable for any indirect, incidental, or consequential damages arising from the use of our products or services.</p>

        <h2>5. Intellectual Property</h2>
        <p>All content, logos, trademarks, and materials on this website are the property of Techno Elevators LLC or our affiliates and are protected under applicable intellectual property laws.</p>

        <h2>6. Amendments</h2>
        <p>We may update these Terms and Conditions from time to time. Continued use of our website or services constitutes acceptance of the updated terms.</p>

        <h2>7. Governing Law</h2>
        <p>These terms are governed by and construed in accordance with the laws of the Sultanate of Oman.</p>
      </div>
     </Container>
      <Footer />
    </>
  )
}

export default TermsAndConditions
